import { Builder, withChildren } from '@builder.io/react';

import Section from '../../elements/section/index';

const SectionWithBuilderChildren = withChildren(Section);

Builder.registerComponent(SectionWithBuilderChildren, {
  name: 'SectionLogoCloud',
  inputs: [
    {
      name: 'id',
      type: 'string'
    },
    {
      name: 'container',
      type: 'boolean'
    },
    {
      name: 'bg',
      type: 'string',
      defaultValue: 'bg-transparent',
      enum: [
        'bg-transparent',
        'bg-neutral-950',
        'bg-neutral-900',
        'bg-neutral-100',
        'bg-neutral-800'
      ]
    },
    {
      name: 'relative',
      type: 'boolean'
    },
    {
      name: 'paddingTop',
      type: 'boolean'
    },
    {
      name: 'paddingBottom',
      type: 'boolean'
    },
    {
      name: 'overflowHidden',
      type: 'boolean'
    }
  ],
  defaultChildren: [
    {
      component: {
        name: 'SectionTitle',
        options: {
          overtitle: 'Duis Mollis',
          title: 'Trusted by World Class Companies',
          subtitle:
            'Sed posuere consectetur est at lobortis. Duis mollis, est non commodo luctus, nisi erat porttitor ligula, eget lacinia odio sem nec elit.Sed posuere consectetur est at lobortis. Duis mollis, est non commodo luctus, nisi erat porttitor ligula, eget lacinia odio.'
        }
      }
    },
    {
      component: {
        name: 'LogoFarm',
        options: {
          logos: [
            {
              logo: {
                '@type': '@builder.io/core:Reference',
                id: '275e6cbc1d114149bac8b2448d125c10',
                model: 'logos'
              }
            },
            {
              logo: {
                '@type': '@builder.io/core:Reference',
                id: '17ee27f8cabb4861a5696781a8f9ea9d',
                model: 'logos'
              }
            },
            {
              logo: {
                '@type': '@builder.io/core:Reference',
                id: '03b3031954c143e7b890f7766691502e',
                model: 'logos'
              }
            },
            {
              logo: {
                '@type': '@builder.io/core:Reference',
                id: '5eae29230f8545bf8f02a3ca190fed68',
                model: 'logos'
              }
            },
            {
              logo: {
                '@type': '@builder.io/core:Reference',
                id: 'a2105fa8eb244d7ea1500abd9434f694',
                model: 'logos'
              }
            },
            {
              logo: {
                '@type': '@builder.io/core:Reference',
                id: '62954d29092147a3afa3a0677cfd0deb',
                model: 'logos'
              }
            },
            {
              logo: {
                '@type': '@builder.io/core:Reference',
                id: '79a56b5c5ed248fb9d9701b85f7793b5',
                model: 'logos'
              }
            },
            {
              logo: {
                '@type': '@builder.io/core:Reference',
                id: '9d9165917e484463a4b23fc3e787da21',
                model: 'logos'
              }
            },
            {
              logo: {
                '@type': '@builder.io/core:Reference',
                id: '1701b0772ad44176a3f76ce52f3b414f',
                model: 'logos'
              }
            },
            {
              logo: {
                '@type': '@builder.io/core:Reference',
                id: '9804ee2401ad4e28b3b5a396189b23e1',
                model: 'logos'
              }
            },
            {
              logo: {
                '@type': '@builder.io/core:Reference',
                id: 'cd7860c77511458eb5fe6c71c9b2d2ec',
                model: 'logos'
              }
            },
            {
              logo: {
                '@type': '@builder.io/core:Reference',
                id: 'ac7fc22fc13f4df8b81ef24269dfe785',
                model: 'logos'
              }
            },
            {
              logo: {
                '@type': '@builder.io/core:Reference',
                id: 'ed3b66afd76648c99fe0754705e01fc9',
                model: 'logos'
              }
            },
            {
              logo: {
                '@type': '@builder.io/core:Reference',
                id: 'f2b4c455d9594455ad412db7b67d5824',
                model: 'logos'
              }
            }
          ]
        }
      }
    }
  ]
});
